<template>
  <div :class="['flex flex-col gap-1', wrapperClass]">
    <label
      v-if="label"
      :for="inputId"
      class="text-sm font-medium text-ink">
      {{ label }}
      <span
        v-if="required"
        class="text-danger ml-0.5"
        >*</span
      >
    </label>
    <div class="relative">
      <span
        v-if="$slots.prefix"
        class="absolute left-3 top-1/2 -translate-y-1/2 text-muted">
        <slot name="prefix" />
      </span>
      <input
        :id="inputId"
        v-bind="$attrs"
        :type="type"
        :value="modelValue"
        :placeholder="placeholder"
        :disabled="disabled"
        :readonly="readonly"
        :class="inputClasses"
        @input="$emit('update:modelValue', $event.target.value)" />
      <span
        v-if="$slots.suffix"
        class="absolute right-3 top-[calc(100%-1rem)] cursor-pointer -translate-y-1/2 text-muted">
        <slot name="suffix" />
      </span>
    </div>
    <p
      v-if="error"
      class="text-xs text-danger">
      {{ error }}
    </p>
    <p
      v-else-if="hint"
      class="text-xs text-muted">
      {{ hint }}
    </p>
  </div>
</template>

<script>
let counter = 0

export default {
  name: 'AppInput',
  inheritAttrs: false,
  props: {
    modelValue: { type: [String, Number], default: '' },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    type: { type: String, default: 'text' },
    error: { type: String, default: '' },
    hint: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    wrapperClass: { type: String, default: '' },
  },
  emits: ['update:modelValue'],
  data() {
    return { inputId: `app-input-${++counter}` }
  },
  computed: {
    hasPrefix() {
      return !!this.$slots.prefix
    },
    hasSuffix() {
      return !!this.$slots.suffix
    },
    inputClasses() {
      return [
        'w-full rounded-lg border bg-surface text-ink text-sm transition-colors',
        'placeholder:text-muted',
        'focus:outline-none focus:border-brand focus:ring-2 focus:ring-brand/20',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        this.error ? 'border-danger focus:border-danger focus:ring-danger/20' : 'border-line',
        this.hasPrefix ? 'pl-9' : 'pl-3',
        this.hasSuffix ? 'pr-9' : 'pr-3',
        'py-2',
      ]
    },
  },
}
</script>
